"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils");
var _antdMaskInput = _interopRequireDefault(require("antd-mask-input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormItem = _form.default.Item;
var phoneValidator = (0, _utils.phoneValidator)();
var EmergencyContactsListForm = function EmergencyContactsListForm(_ref) {
  var form = _ref.form,
    contact = _ref.contact,
    onSubmit = _ref.onSubmit;
  var getFieldDecorator = form.getFieldDecorator;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFields(function (err, values) {
      if (err) {
        return;
      }
      onSubmit(values);
    });
  };
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "emergency-contacts-form"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('firstName', {
    initialValue: contact.firstName,
    rules: [{
      required: true,
      message: 'Please enter a first name'
    }, _utils.whitespaceValidator]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "First Name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('lastName', {
    initialValue: contact.lastName,
    rules: [{
      required: true,
      message: 'Please enter a last name'
    }, _utils.whitespaceValidator]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Last Name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('phoneNumber', {
    initialValue: contact.phoneNumber,
    getValueFromEvent: function getValueFromEvent(e) {
      var val = e.target.value;
      return val && "".concat(val).replace(/[()\s-]/g, '').slice(0, 10);
    },
    rules: [{
      required: true,
      message: 'Please enter a phone number'
    }, {
      validator: phoneValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_antdMaskInput.default, {
    mask: "(111) 111-1111",
    name: "phone",
    placeholder: "(555) 555-5555",
    addonAfter: "Phone",
    size: "large",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('relationship', {
    initialValue: contact.relationship,
    rules: [{
      required: true,
      message: 'Please enter relationship'
    }, _utils.whitespaceValidator]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Relationship",
    size: "large"
  }))))), /*#__PURE__*/_react.default.createElement(FormItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    size: "large",
    htmlType: "submit",
    style: {
      width: '100%'
    }
  }, "Save Changes")));
};
EmergencyContactsListForm.propTypes = {
  form: _propTypes.default.object.isRequired,
  contact: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    phoneNumber: _propTypes.default.string,
    email: _propTypes.default.string,
    address: _propTypes.default.objectOf(_propTypes.default.shape({
      addressLine1: _propTypes.default.string,
      addressLine2: _propTypes.default.string,
      city: _propTypes.default.string,
      state: _propTypes.default.string,
      zipCode: _propTypes.default.string,
      countryCode: _propTypes.default.string
    })),
    relationship: _propTypes.default.string
  }),
  onSubmit: _propTypes.default.func.isRequired,
  onAddContact: _propTypes.default.func.isRequired,
  onDeleteContact: _propTypes.default.func.isRequired
};
var _default = _form.default.create()(EmergencyContactsListForm);
exports.default = _default;